import {
  IAnalyticsRepository,
  IAnalyticsRepositoryParams,
  IDeductionVolumeVsGrossSalesRepositoryResponse,
} from "@/core/repositories/analytics";

export class GetDeductionVolumeVsGrossSalesUseCase {
  constructor(private readonly repo: IAnalyticsRepository) {}

  async execute(params: IAnalyticsRepositoryParams): Promise<IDeductionVolumeVsGrossSalesRepositoryResponse> {
    return this.repo.getDeductionVolumeVsGrossSales(params);
  }
}
